import { useQuery } from 'react-query';

import useApiHelper from '../../hooks/useApiHelper';

import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';
import { IActionWithInputType } from '../../types/Action/Action';
import { actionQueryKeys } from '../QueryKeys';

export default function useActionsByAppliance(applianceId: string) {
  const { get } = useApiHelper();

  const actions = useQuery({
    queryKey: actionQueryKeys.superAdminAll(),
    queryFn: () =>
      get<IDefaultResponseWithData<IActionWithInputType>>(
        `/v1/action/${applianceId}`
      ).then((res) => res.data.data),
  });

  return {
    actions,
  };
}
